import { ConversationSummary } from '@types';

import { addCoreAgentConversationTitles, updateCoreAgentConversationTitle } from '../titles/actions';
import { call, put } from 'redux-saga/effects';
import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';
import { ErrorOrFailStatusCode, HttpResponse } from '@sonar-software/sonar-http';
import { getConversation, GetConversationRequest } from '@api';

function* requestConversationHeader(request: GetConversationRequest) {
	// xuder reports a rejected fetch globally, which a background poll should not surface.
	const response: HttpResponse<ConversationSummary> = yield call(() => getConversation(request).catch(() => ({
		headers: new Headers(),
		status: ErrorOrFailStatusCode.RequestTimeout
	})));

	if (response.status === ErrorOrFailStatusCode.NotFound) {
		yield put(updateCoreAgentConversationTitle({
			id: request.id,
			status: 'gaveUp'
		}));
	}

	return response;
}

export const getCoreAgentConversationHeaderSlice = createGetAsyncSlice<
	'coreAgentConversationHeader',
	GetConversationRequest,
	ConversationSummary
>({
	httpSagaOptions: {
		successDataActionCreators: [ (header) => addCoreAgentConversationTitles([ header ]) ]
	},
	name: 'coreAgentConversationHeader',
	receive: true,
	request: true,
	requestHandler: requestConversationHeader,
	yieldType: SagaYieldType.Every
});
